<div class="status tw-flex tw-items-center tw-gap-2">
  @for (badge of statusBadges(); track badge.trackId) {
    <rv-badge
      [color]="badge.color"
      [shape]="badgeShape()"
      [icon]="badge.icon"
      [text]="badge.text"
      [ariaLabel]="badgeShape() === 'icon' ? (badge.tooltip ?? null) : null"
      [matTooltip]="badge.tooltip ?? ''"
      [matTooltipDisabled]="badgeShape() === 'chip'"
      matTooltipClass="rv-badge-tooltip"
    />
  }
</div>
